module.exports = __webpack_public_path__ + "static/6-068eb1a69189483ad49ae5f7248071a7.jpg";